import React from 'react';
import PropTypes from 'prop-types';
import BaseHeader from './BaseHeader';
import BaseBody from './BaseBody';
import classnames from 'classnames';
import { KeyCode, DateUtil } from '../util';
import { getLangCode } from '@platform/api';

const MONTH_PREV_NEXT_CHANGE_NUM = 1;

function MonthHeader(props){
    const {
        onPrevYear,
        onNextYear,
        onYearClick,
        viewDate,
    } = props;
    return (
        <BaseHeader
            onSuperPrev={onPrevYear}
            onSuperNext={onNextYear}
        >
            <button onClick={onYearClick}>{DateUtil.getYear(viewDate)}</button>
        </BaseHeader>
    );
}

function MonthBody(props){
    const { viewDate, locale, renderCellContent } = props;

    function monthRender(date) {
        let month = DateUtil.getMonth(date);
        if(getLangCode() === 'english'){
            month = DateUtil.toDayjs(date).format('MMM');
        } else {
            month = month.toString().concat(locale["0001"]);
        }
        return month;
    }

    return (
        <BaseBody 
            {...props}
            rowNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_ROW_NUM} 
            colNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM}
            firstShowDate={DateUtil.setMonth(viewDate, 0)} 
            renderCellNode={monthRender}
            calculateCellDate={DateUtil.addMonth}
            renderCellContent={renderCellContent || DateUtil.getMonth}
            renderCellTitle={monthRender}
        />
    );
}

class MonthPanel extends React.Component{

    static defaultProps = {
        superNext: true,
        superPrev: true,
    }
    
    handleMonthSelect = (date, event) => {
        const { onChange, picker, onSelect, onPanelChange } = this.props;
        onSelect?.(date, 'month');
        if(picker === 'month'){
            onChange?.(date, event);
        } else {
            onPanelChange?.('date', date);
        }
    }

    handleYearChange = diff => {
        const { viewDate, onPanelChange } = this.props;
        let newDate = DateUtil.addYear(viewDate, diff);
        onPanelChange?.('month', newDate);
    }

    onKeyDown = event => {
        const { onSelect, viewDate, onPanelChange, onChange } = this.props;
        // console.log('月面板的按键事件', event.keyCode);
        let newDate = viewDate;
        switch(event.keyCode){
            case KeyCode.LEFT:
                newDate = DateUtil.addMonth(viewDate, -1);
                onSelect?.(newDate, 'month');
                break;
            case KeyCode.UP:
                newDate = DateUtil.addMonth(viewDate, -DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM);
                onSelect?.(newDate, 'month');
                break;
            case KeyCode.RIGHT:
                newDate = DateUtil.addMonth(viewDate, 1);
                onSelect?.(newDate, 'month');
                break;
            case KeyCode.DOWN:
                newDate = DateUtil.addMonth(viewDate, DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM);
                onSelect?.(newDate, 'month');
                break;
            case KeyCode.ENTER:
                onSelect?.(newDate, 'month');
                onChange?.(newDate, event);
                break;
            default: 
                return true;
        }
        event.preventDefault();
        if(!DateUtil.isSame(viewDate, newDate, 'year')){
            onPanelChange?.('month', newDate);
        }
        return false;
    }

    render(){
        const { 
            viewDate, 
            onPanelChange, 
            superNext,
            superPrev,
            panelWrapperProps,
            ...other 
        } = this.props;
        return (
            <div
                className={classnames({
                    "picker-panel-content": true,
                    "picker-month-panel": true,
                })}
                {...panelWrapperProps}
            >
                <MonthHeader 
                    onPrevYear={superPrev && this.handleYearChange.bind(this, -MONTH_PREV_NEXT_CHANGE_NUM)} 
                    onNextYear={superNext && this.handleYearChange.bind(this, MONTH_PREV_NEXT_CHANGE_NUM)}
                    onYearClick={() => onPanelChange('year', viewDate)}
                    viewDate={viewDate}
                />
                <MonthBody 
                    {...other} 
                    viewDate={viewDate} 
                    onSelect={this.handleMonthSelect} 
                />
            </div>
        );
    }
}

MonthPanel.PropTypes = {
    viewDate: PropTypes.object.isRequired, // Date类型
    locale: PropTypes.object.isRequired,
    superPrev: PropTypes.bool,
    superNext: PropTypes.bool,
    picker: PropTypes.string,
    onPanelChange: PropTypes.func,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    onDateMouseEnter: PropTypes.func,
    onDateMouseLeave: PropTypes.func,
};

export default MonthPanel;

